import type { ClassroomScope } from "./classroomScope";
import { useClassroomName, useClassroomRoster } from "./useClassroomData";

/**
 * Names for the classroom and student a page is about. Both come from lists the classroom pages
 * already hold, so this costs nothing beyond a cache read once the roster has loaded.
 */
export function useStudentContext(scope: ClassroomScope, classroomId: string, studentId: string) {
  const classroomName = useClassroomName(scope, classroomId);
  const { students } = useClassroomRoster(scope, classroomId);

  return {
    classroomName,
    student: students.find((item) => item.userId === studentId) ?? null,
  };
}
